import { AgeCategoryState } from './state';
import { AGE_CHANGE, AgeCategoryAction } from './types';
import { AgeCategory } from '../../../models/AgeCategory';
import { LOCATION_CHANGE, LocationChangeAction } from 'connected-react-router';
import queryString from 'query-string';

const initialAgeCategoryState = AgeCategory.ALL_AGES;

export default function ageCategoryReducer(
    state: AgeCategoryState = initialAgeCategoryState,
    action: AgeCategoryAction | LocationChangeAction
): AgeCategoryState {
    switch (action.type) {
        case AGE_CHANGE:
            return action.payload;
        case LOCATION_CHANGE:
            return reduceLocationChange(state, action);
        default:
            return state;
    }
}

function reduceLocationChange(state: AgeCategoryState, action: LocationChangeAction): AgeCategoryState {
    const queryParams = queryString.parse(action.payload.location.search);
    const ageCategory = queryParams['ageCategory'];

    if (typeof ageCategory !== 'string') {
        return AgeCategory.ALL_AGES;
    }

    switch (ageCategory.toLowerCase()) {
        case 'adult':
            return AgeCategory.ADULT;
        case 'young adult':
            return AgeCategory.YOUNG_ADULT;
        case 'children':
            return AgeCategory.CHILDREN;
        case 'all ages':
            return AgeCategory.ALL_AGES;
        default:
            return AgeCategory.ALL_AGES;
    }
}
